import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';

// 孔雀蓝 .page-head 中按钮样式
var pageHeadButtonStyle = function pageHeadButtonStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    fontColor = _getThemeData.fontColor,
    primary = _getThemeData.primary;
  var _getThemeData2 = getThemeData(props, 'button'),
    pageHeadPrimaryBtnBgColor = _getThemeData2.pageHeadPrimaryBtnBgColor,
    pageHeadPrimaryBtnPadding = _getThemeData2.pageHeadPrimaryBtnPadding;
  return css([".page-head{&&&{.c7n-pro-btn:not(.c7n-pro-btn-flat).c7n-pro-btn-primary{padding:", ";background-color:", ";border-color:", ";color:", ";:hover{background-color:", ";border-color:", ";}}.page-head-operator > .c7n-pro-btn:not(:last-child),.page-head-operator > .page-head-operation:not(:last-child){margin-left:8px;}}}.page-head-operator{&&&&{.c7n-pro-btn-primary:not(.c7n-pro-btn-flat),.c7n-pro-btn-primary:not(.c7n-pro-btn-flat):active,.c7n-pro-btn-primary:not(.c7n-pro-btn-flat):focus{padding:", ";background-color:", ";border-color:", ";color:", ";}}}"], pageHeadPrimaryBtnPadding, pageHeadPrimaryBtnBgColor, pageHeadPrimaryBtnBgColor, fontColor, primary, primary, pageHeadPrimaryBtnPadding, pageHeadPrimaryBtnBgColor, pageHeadPrimaryBtnBgColor, fontColor);
};
var buttonData = {
  name: 'button',
  // 开启 fusionTemplate 将theme2 模板与 theme5 模板融合
  fusionTemplate: true,
  data: [{
    pageHeadPrimaryBtnBgColor: '#1e3255',
    pageHeadPrimaryBtnPadding: '0 12px !important',
    flatBtnHoverBgColor: 'rgba(0,0,0,.08)',
    minWidth: 'auto',
    smMinWidth: 'auto'
  }],
  onlyTemplate: {
    pro: pageHeadButtonStyle
  }
};
export default buttonData;